module.exports = {
  1: 'VERY LOW',
  2: 'LOW',
  3: 'MODERATE',
  4: 'HIGH'
};
